import type { World } from '../world';

export function animSystem(world: World, dt: number): void {
  for (const e of world.entities.values()) {
    if (e.kind === 'projectile' || e.kind === 'pickup' || e.kind === 'hazard') continue;
    e.animTime += dt;
    const attackEnd = e.kind === 'monster' ? Math.max(0.3, e.windupMax + 0.25) : 0.3;
    if (e.anim === 'hit' && e.animTime > 0.25) { e.anim = 'idle'; e.animTime = 0; }
    else if (e.anim === 'attack' && e.animTime > attackEnd) { e.anim = 'idle'; e.animTime = 0; }
    else if (e.anim === 'die' && (e.kind === 'monster' || e.kind === 'summon') && e.animTime > (e.kind === 'monster' && e.boss ? 2.2 : 1.2)) world.entities.delete(e.id);
  }
}
